import cn from "classnames";
import { Fragment, useEffect, useState } from "react";
import Card from "../../components/Card";
import { UseApi } from "../../hooks/use-api";
import {
	AddressCreate,
	GetAddressList,
	DeleteAddress,
} from "../../Services/lib/brand";
import { UseDisclosure } from "../../hooks/use-disclosure";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import Loader from "../../components/Loader";
import style from "./Addresses.module.sass";
import Empthy from "../../components/Empty";
import TextInput from "../../components/TextInput";
import Modal from "../../components/Modal";
import CountryCodes from "./countryCode.json";
import Dropdown from "../../components/Dropdown";
import Schedule from "../../components/Schedule";
import { useUser } from "../../context";
import settings from "../../i11/Settings";
import Icon from "../../components/Icon";
import Confirm from "../../components/Confirm";

const dimensionValue = {
	Inches: { code: "IN", desc: "Inches", title: "Inches" },
	Centimeters: {
		code: "CM",
		desc: "Centimeters",
		title: "Centimeters",
	},
};

const weightValue = {
	Pounds: { code: "LBS", desc: "Pounds", title: "Pounds" },
	Kilograms: {
		code: "KGS",
		desc: "Kilograms",
		title: "Kilograms",
	},
};

const Addresses = () => {
	const { locale } = useUser();
	const [visibleDelete, setVisibleDelete] = useState();
	const [removeID, setID] = useState();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [{ data, isLoading }, getAddresses] = UseApi({
		service: GetAddressList,
	});
	const [{ isLoading: loadingDelete }, deleteAdd] = UseApi({
		service: DeleteAddress,
		successMsg: "Success",
	});
	useEffect(() => {
		getAddresses();
	}, []);
	const Close = () => {
		onClose();
	};
	return (
		<Card
			title={settings[locale].address_book}
			classTitle="title-green"
			head={
				<button className="button-small" onClick={onOpen}>
					{settings[locale].add}
				</button>
			}
		>
			<div>
				{isLoading ? (
					<div className={style.loaderWrap}>
						<Loader />
					</div>
				) : data?.length > 0 ? (
					<div>
						<div className={style.table}>
							<div>{settings[locale].addressline}</div>
							<div>{settings[locale].div2}</div>
							<div>{settings[locale].div1}</div>
							<div>{settings[locale.country]}</div>
							<div />
						</div>
						{data.map((e, i) => {
							return (
								<div
									key={e._id}
									className={cn(style.table, style.visibleDelete)}
								>
									<div>{e.AddressLineString}</div>
									<div>{e.PoliticalDivision2}</div>
									<div>{e.PoliticalDivision1}</div>
									<div>{e.CountryCode}</div>
									<div className={style.btns}>
										<button
											onClick={() => {
												setID(e._id);
												setVisibleDelete(true);
											}}
										>
											<Icon name="trash" fill={"red"} size="18px" />
										</button>
									</div>
								</div>
							);
						})}
					</div>
				) : (
					<Empthy />
				)}
			</div>
			<Modal
				outSideClickNone
				outerClassName={style.modal}
				visible={isOpen}
				onClose={Close}
			>
				{isOpen && <Create getAddresses={getAddresses} onClose={Close} />}
			</Modal>

			<Modal visible={visibleDelete} onClose={() => setVisibleDelete(false)}>
				<Confirm
					title={settings[locale].rm_address}
					onCancel={() => {
						setVisibleDelete(false);
					}}
					onConfirm={async () => {
						const res = await deleteAdd(removeID);
						if (res) {
							getAddresses();
							setVisibleDelete(false);
						}
					}}
					isLoading={loadingDelete}
				></Confirm>
			</Modal>
		</Card>
	);
};

const Create = ({
	onClose,
	getAddresses,
	initial = {
		AddressLine: {
			addr1: "",
			addr2: "",
		},
		PoliticalDivision1: "",
		PoliticalDivision2: "",
		PostcodePrimaryLow: "",
		CountryCode: "",
		pickUpStartHours: "0900",
		pickUpEndHours: "1700",
		dimensionUnit: {
			Code: "",
			Description: "",
		},
		weightUnit: {
			Code: "",
			Description: "",
		},
	},
}) => {
	const { locale } = useUser();
	const [{ isLoading }, create] = UseApi({
		service: AddressCreate,
	});
	const [state, setState] = useState({ ...initial });
	const handler = (name, e) => {
		setState((p) => {
			return {
				...p,
				[name]: e,
			};
		});
	};
	const submitHandler = async (e) => {
		e.preventDefault();
		const tmp = {
			...state,
			AddressLine: [state.AddressLine.addr1, state.AddressLine.addr2],
			AddressLineString: [
				state.AddressLine.addr1,
				state.AddressLine.addr2,
			].join(" "),
		};
		if (!tmp.dimensionUnit.Code || !tmp.weightUnit.Code) {
			ToastEmitter({
				type: "info",
				msg: `${
					!tmp.dimensionUnit.Code ? "Dimension " : "Weight "
				} Unit is empty! `,
			});
			return;
		}
		const res = await create(tmp);
		if (res) {
			getAddresses();
			onClose();
			ToastEmitter({
				type: "success",
				msg: "Successfully created new address",
			});
		}
	};
	return (
		<Card title={settings[locale].create_address} classTitle="title-red">
			<form onSubmit={submitHandler} className={style.grid}>
				{Object.keys(state).map((e) => {
					if (e === "pickUpEndHours" || e === "pickUpStartHours") return;
					if (e === "CountryCode")
						return (
							<div className={style.inpuut}>
								<Dropdown
									tooltip="Selecting full-width will make the banner cover the full horizontal width of the page. Selecting half-width will cover half the horizontal width"
									value={state[e]}
									setValue={(val) => handler(e, val)}
									options={Object.keys(CountryCodes)}
									dictionary={CountryCodes}
									label={settings[locale].address_dic[e].label}
								/>
							</div>
						);
					if (e === "AddressLine")
						return (
							<Fragment key={e}>
								<TextInput
									onInvalid={(ev) =>
										ev.target.setCustomValidity(
											settings[locale].address_dic[e].validation.default
										)
									}
									placeHolder={settings[locale].address_dic[e].holder1}
									required
									value={state[e].addr1}
									onChangeInput={(val) => {
										setState((p) => {
											return {
												...p,
												AddressLine: {
													...p.AddressLine,
													addr1: val,
												},
											};
										});
									}}
									label={settings[locale].address_dic[e].label}
								/>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-end",
									}}
								>
									<TextInput
										onInvalid={(ev) =>
											ev.target.setCustomValidity(
												settings[locale].address_dic[e].validation.default
											)
										}
										placeHolder={settings[locale].address_dic[e].holder2}
										required
										value={state[e].addr2}
										onChangeInput={(val) => {
											setState((p) => {
												return {
													...p,
													AddressLine: {
														...p.AddressLine,
														addr2: val,
													},
												};
											});
										}}
									/>
								</div>
							</Fragment>
						);
					if (e === "dimensionUnit")
						return (
							<div className={style.inpuut}>
								<Dropdown
									value={state[e].Description}
									setValue={(val) => {
										setState((p) => {
											return {
												...p,
												[e]: {
													Code: dimensionValue[val].code,
													Description: dimensionValue[val].desc,
												},
											};
										});
									}}
									options={Object.keys(dimensionValue)}
									dictionary={dimensionValue}
									label={settings[locale].address_dic[e].label}
								/>
							</div>
						);
					if (e === "weightUnit")
						return (
							<div className={style.inpuut}>
								<Dropdown
									value={state[e].Description}
									setValue={(val) => {
										setState((p) => {
											return {
												...p,
												[e]: {
													Code: weightValue[val].code,
													Description: weightValue[val].desc,
												},
											};
										});
									}}
									options={Object.keys(weightValue)}
									dictionary={weightValue}
									label={settings[locale].address_dic[e].label}
								/>
							</div>
						);
					return (
						<TextInput
							onInvalid={(ev) =>
								ev.target.setCustomValidity(
									settings[locale].address_dic[e].validation.default
								)
							}
							placeHolder={settings[locale].address_dic[e].holder}
							required
							value={state[e]}
							onChangeInput={(val) => {
								handler(e, val);
							}}
							label={settings[locale].address_dic[e].label}
							key={e}
						/>
					);
				})}
				<DateCompoenent state={state} handler={handler} />
				<div className={style.flexend}>
					<button className={cn("button", { disabled: isLoading })}>
						{isLoading && <Loader />} Save
					</button>
				</div>
			</form>
		</Card>
	);
};

const initDate = (strt) => {
	if (strt) {
		const date = new Date();
		date.setHours(9);
		date.setMinutes(0);
		return date;
	} else {
		const date = new Date();
		date.setHours(17);
		date.setMinutes(0);
		return date;
	}
};

const getValue = (date) => {
	const h = date.getHours();
	const m = date.getMinutes();
	return `${h.toString().length === 1 ? "0" + h : h}${
		m.toString().length === 1 ? "0" + m : m
	}`;
};

const DateCompoenent = ({ handler }) => {
	const { locale } = useUser();
	const [startDate, setStartDate] = useState(initDate(true));
	const [endDate, setEndDate] = useState(initDate(false));
	const {
		onOpen: startOpen,
		onClose: startClose,
		isOpen: startIsOpen,
	} = UseDisclosure();
	const {
		onOpen: endOpen,
		onClose: endClose,
		isOpen: endIsOpen,
	} = UseDisclosure();

	useEffect(() => {
		handler("pickUpStartHours", getValue(startDate));
		handler("pickUpEndHours", getValue(endDate));
	}, [startDate, endDate]);

	return (
		<>
			<TextInput
				onClick={() => {
					startOpen();
				}}
				onInvalid={(ev) =>
					ev.target.setCustomValidity(
						settings[locale].address_dic.pickUpStartHours.validation.default
					)
				}
				placeHolder={settings[locale].address_dic.pickUpStartHours.holder}
				required
				value={startDate.toLocaleTimeString("en-US", {
					hour: "2-digit",
					minute: "2-digit",
				})}
				onChangeInput={(val) => {
					startOpen();
				}}
				label={settings[locale].address_dic.pickUpStartHours.label}
			/>
			<div
				onClick={() => {
					endOpen();
				}}
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "flex-end",
				}}
			>
				<TextInput
					onInvalid={(ev) =>
						ev.target.setCustomValidity(
							settings[locale].address_dic.pickUpEndHours.validation.default
						)
					}
					value={endDate.toLocaleTimeString("en-US", {
						hour: "2-digit",
						minute: "2-digit",
					})}
					placeHolder={settings[locale].address_dic.pickUpEndHours.holder}
					required
					onChangeInput={() => {
						endOpen();
					}}
					label={settings[locale].address_dic.pickUpEndHours.label}
				/>
			</div>
			<Modal visible={startIsOpen} onClose={startClose}>
				<Schedule
					onClick={startClose}
					startDate={startDate}
					setStartDate={setStartDate}
					nobutton
					nodate
					note=""
				/>
			</Modal>	
			<Modal visible={endIsOpen} onClose={endClose}>
				<Schedule
					onClick={endClose}
					startDate={endDate}
					setStartDate={setEndDate}
					nobutton
					nodate
					note=""
				/>
			</Modal>
		</>
	);
};

export default Addresses;
